var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _circle2, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9,
    cy: 7.2,
    fill: "#fff27d",
    rx: 8,
    ry: 2.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e76f",
    d: "M16,6.12a.52.52,0,0,1,0,.21c0,1.2-3.58,2.2-8,2.2A17.72,17.72,0,0,1,1,7.4c.37,1.12,3.79,2,8,2,4.42,0,8-1,8-2.2C17,6.81,16.62,6.44,16,6.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc661",
    d: "M17,7.2v5.86c0,1.22-3.58,2.2-8,2.2s-8-1-8-2.2V7.2C1,8.41,4.58,9.4,9,9.4S17,8.41,17,7.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7b54b",
    d: "M9.5,14.45c-4.42,0-8-1-8-2.2V8A1,1,0,0,1,1,7.2v5.86c0,1.22,3.58,2.2,8,2.2s8-1,8-2.2V13C15.87,13.85,13,14.45,9.5,14.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff27d",
    d: "M17,13.06v5.88c0,1.21-3.58,2.2-8,2.2s-8-1-8-2.2V13.06c0,1.22,3.58,2.2,8,2.2S17,14.28,17,13.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e76f",
    d: "M9.5,20.32c-4.42,0-8-1-8-2.2V13.83a1,1,0,0,1-.5-.76v5.87c0,1.22,3.58,2.2,8,2.2s8-1,8-2.2v-.05C15.87,19.73,13,20.32,9.5,20.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc661",
    d: "M17,18.94V24.8C17,26,13.42,27,9,27s-8-1-8-2.2V18.94c0,1.21,3.58,2.2,8,2.2S17,20.15,17,18.94Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7b54b",
    d: "M9.5,26.19c-4.42,0-8-1-8-2.2V19.7a1,1,0,0,1-.5-.76V24.8C1,26,4.58,27,9,27s8-1,8-2.2v-.05C15.87,25.59,13,26.19,9.5,26.19Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 9,
    fill: "#ffc661"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7b54b",
    d: "M23.09,26.1a9,9,0,0,1-6.23-15.48A9,9,0,1,0,28.23,24.48,8.94,8.94,0,0,1,23.09,26.1Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 18,
    r: 6,
    fill: "#fff27d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7e76f",
    d: "M23,23a6,6,0,0,1-4.76-9.64,6,6,0,1,0,8.52,8.31A6,6,0,0,1,23,23Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.24ac9c0c3451d4f2da8170ec0765a791.svg";
export { ForwardRef as ReactComponent };